import React from "react";

function PlusInCircleIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
            >
                  <rect
                        width="48.941"
                        height="48.941"
                        x="0.56"
                        y="0.5"
                        fill="#fff"
                        rx="24.471"
                  ></rect>
                  <rect
                        width="48.941"
                        height="48.941"
                        x="0.56"
                        y="0.5"
                        stroke="#005BB2"
                        rx="24.471"
                  ></rect>
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M25.03 30.97v-12M31.03 24.97h-12"
                  ></path>
            </svg>
      );
}

export default PlusInCircleIcon;
